var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./react-table.ts" />
import * as React from 'react';
import { useTable, useSortBy, useFlexLayout, useFilters, useExpanded, useRowState, } from 'react-table';
import { useSticky } from 'react-table-sticky';
import { styled, css } from 'styled-components';
import TableHeaderCell, { ScTh } from './TableHeaderCell';
import { TableRow } from './TableRow';
var ScTableHead = styled.thead.withConfig({ displayName: "ScTableHead", componentId: "sc-sz2anv" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: 0px 16px 16px -16px rgba(0, 0, 0, 0.1);\n  min-width: min-content;\n"], ["\n  background-color: ", ";\n  box-shadow: 0px 16px 16px -16px rgba(0, 0, 0, 0.1);\n  min-width: min-content;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
});
var ScTableBody = styled.tbody.withConfig({ displayName: "ScTableBody", componentId: "sc-438c6l" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: initial;\n  min-width: min-content;\n"], ["\n  position: initial;\n  min-width: min-content;\n"])));
var ScTable = styled.table.withConfig({ displayName: "ScTable", componentId: "sc-1w8f9vr" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border-collapse: separate;\n  width: 100%;\n  box-sizing: border-box;\n\n  * {\n    box-sizing: inherit;\n  }\n\n  ", "\n\n  ", "\n"], ["\n  border-collapse: separate;\n  width: 100%;\n  box-sizing: border-box;\n\n  * {\n    box-sizing: inherit;\n  }\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var isFlexLayout = _a.isFlexLayout;
    return isFlexLayout && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
}, function (_a) {
    var sticky = _a.sticky, stickyHeaderTopOffset = _a.stickyHeaderTopOffset, theme = _a.theme;
    return sticky && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      overflow: scroll;\n\n      ", " {\n        position: sticky;\n        z-index: 10;\n        width: fit-content;\n        top: ", "px;\n      }\n\n      ", " {\n        position: relative;\n        z-index: 0;\n      }\n\n      *[data-sticky-td] {\n        position: sticky;\n      }\n\n      ", "[data-sticky-td] {\n        background-color: ", ";\n      }\n    "], ["\n      overflow: scroll;\n\n      ", " {\n        position: sticky;\n        z-index: 10;\n        width: fit-content;\n        top: ", "px;\n      }\n\n      ", " {\n        position: relative;\n        z-index: 0;\n      }\n\n      *[data-sticky-td] {\n        position: sticky;\n      }\n\n      ", "[data-sticky-td] {\n        background-color: ", ";\n      }\n    "])), ScTableHead, stickyHeaderTopOffset !== null && stickyHeaderTopOffset !== void 0 ? stickyHeaderTopOffset : 0, ScTableBody, ScTh, theme.colors.white);
});
function Table(_a) {
    var columns = _a.columns, data = _a.data, defaultColumns = _a.defaultColumns, sortColumn = _a.sortColumn, sortDirection = _a.sortDirection, onSortHeaderClick = _a.onSortHeaderClick, hiddenColumns = _a.hiddenColumns, hiddenHeaderGroupsByIdx = _a.hiddenHeaderGroupsByIdx, filterColumn = _a.filterColumn, _b = _a.isFlexLayout, isFlexLayout = _b === void 0 ? true : _b, initialState = _a.initialState, getRowId = _a.getRowId, isHeaderHidden = _a.isHeaderHidden, clearSorting = _a.clearSorting, renderSubRow = _a.renderSubRow, onSortChange = _a.onSortChange, getAdditionalRowProps = _a.getAdditionalRowProps, getAdditionalCellProps = _a.getAdditionalCellProps, renderRowContent = _a.renderRowContent, updateRow = _a.updateRow, stickyHeader = _a.stickyHeader, stickyHeaderTopOffset = _a.stickyHeaderTopOffset, testId = _a.testId, restProps = __rest(_a, ["columns", "data", "defaultColumns", "sortColumn", "sortDirection", "onSortHeaderClick", "hiddenColumns", "hiddenHeaderGroupsByIdx", "filterColumn", "isFlexLayout", "initialState", "getRowId", "isHeaderHidden", "clearSorting", "renderSubRow", "onSortChange", "getAdditionalRowProps", "getAdditionalCellProps", "renderRowContent", "updateRow", "stickyHeader", "stickyHeaderTopOffset", "testId"]);
    var stateReducer = React.useCallback(function (newState, action, prevState) {
        if (action.type === 'toggleSortBy') {
            if (!onSortHeaderClick) {
                return newState;
            }
            // skip change state, if newState.sortBy equal prevState.sortBy
            if (newState.sortBy.length === prevState.sortBy.length &&
                newState.sortBy.every(function (elem, idx) {
                    return elem.id === prevState.sortBy[idx].id &&
                        elem.desc === prevState.sortBy[idx].desc;
                })) {
                return prevState;
            }
            // change outside sorting, when change inner sorting by columnHeaderClick
            var tableSortBy = newState.sortBy;
            if (tableSortBy.length === 1) {
                onSortHeaderClick({
                    columnId: tableSortBy[0].id,
                    sort: tableSortBy[0].desc ? 'desc' : 'asc',
                });
            }
            else {
                onSortHeaderClick(undefined);
            }
            return newState;
        }
        return newState;
    }, [onSortHeaderClick]);
    var optionalLibHooks = React.useMemo(function () {
        var hooksList = [];
        if (isFlexLayout) {
            hooksList.push(useFlexLayout);
        }
        return hooksList;
    }, [isFlexLayout]);
    var _c = useTable.apply(void 0, __spreadArray(__spreadArray([__assign({ initialState: initialState, columns: columns, data: data, defaultColumns: defaultColumns, stateReducer: stateReducer, getRowId: getRowId }, restProps)], optionalLibHooks, false), [useSticky,
        useFilters,
        useSortBy,
        useExpanded,
        useRowState], false)), getTableProps = _c.getTableProps, getTableBodyProps = _c.getTableBodyProps, headerGroups = _c.headerGroups, rows = _c.rows, prepareRow = _c.prepareRow, toggleSortBy = _c.toggleSortBy, setSortBy = _c.setSortBy, setHiddenColumns = _c.setHiddenColumns, setFilter = _c.setFilter, visibleColumns = _c.visibleColumns, toggleAllRowsExpanded = _c.toggleAllRowsExpanded, sortBy = _c.state.sortBy;
    // change inner sorting by change outside
    React.useEffect(function () {
        if (sortColumn && sortDirection) {
            toggleSortBy(sortColumn, sortDirection === 'desc');
        }
    }, [toggleSortBy, sortColumn, sortDirection]);
    React.useEffect(function () {
        if (clearSorting)
            setSortBy([]);
    }, [setSortBy, clearSorting]);
    React.useEffect(function () {
        if (hiddenColumns) {
            setHiddenColumns(hiddenColumns);
        }
    }, [hiddenColumns, setHiddenColumns]);
    React.useEffect(function () {
        if (filterColumn) {
            setFilter(filterColumn.columnId, filterColumn.value);
        }
    }, [filterColumn, setFilter]);
    var hasStickyColumns = React.useMemo(function () { return columns.some(function (_a) {
        var sticky = _a.sticky;
        return Boolean(sticky);
    }); }, [columns]);
    React.useEffect(function () {
        onSortChange === null || onSortChange === void 0 ? void 0 : onSortChange(sortBy);
        toggleAllRowsExpanded(false);
    }, [onSortChange, sortBy, toggleAllRowsExpanded]);
    return (_jsxs(ScTable, __assign({ isFlexLayout: isFlexLayout, sticky: hasStickyColumns || stickyHeader, stickyHeaderTopOffset: stickyHeaderTopOffset, "data-testid": testId }, getTableProps(), { children: [!isHeaderHidden && (_jsx(ScTableHead, { children: headerGroups.map(function (headerGroup, idx) {
                    if (hiddenHeaderGroupsByIdx === null || hiddenHeaderGroupsByIdx === void 0 ? void 0 : hiddenHeaderGroupsByIdx.includes(idx)) {
                        return null;
                    }
                    return (_jsx("tr", __assign({}, headerGroup.getHeaderGroupProps(), { children: headerGroup.headers.map(function (column) { return (_jsx(TableHeaderCell, __assign({ column: column }, column.getHeaderProps([
                            column.getSortByToggleProps(),
                            { style: column.style, title: undefined },
                        ])), void 0)); }) }), void 0));
                }) }, void 0)), _jsx(ScTableBody, __assign({}, getTableBodyProps(), { children: rows.map(function (row, rowIdx) {
                    prepareRow(row);
                    return (_jsx(TableRow, { row: row, rowIdx: rowIdx, rowsLength: rows.length, columnsLength: visibleColumns.length, getAdditionalRowProps: getAdditionalRowProps, getAdditionalCellProps: getAdditionalCellProps, renderRowContent: renderRowContent, renderSubRow: renderSubRow, updateRow: updateRow }, row.getRowProps().key));
                }) }), void 0)] }), void 0));
}
export { Table };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
